var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 1c2.209.00022 4 1.791 4 4v2H5.9432l-.26172 8.8828c-.02894.984-.04663 1.6208-.02735 2.1084.01861.4702.06879.6491.10157.7334.19584.5039.58804.9067 1.08593 1.1172.08353.0352.26109.0907.7295.123.48679.0336 1.12429.0352 2.10839.0352h4.64258c.9843 0 1.6216-.0015 2.1084-.0352.4686-.0323.6461-.0878.7295-.123.4977-.2106.8901-.6134 1.0859-1.1172.0328-.0844.083-.2635.1016-.7334.0193-.4876.0016-1.1244-.0273-2.1084L18.117 10h2.001l.2012 5.8232c.0562 1.9128.0847 2.8702-.209 3.626-.3916 1.0076-1.1753 1.8142-2.1709 2.2354-.7468.3157-1.7041.3154-3.6172.3154H9.67952c-1.9131 0-2.87039.0002-3.61718-.3154-.99569-.4211-1.77819-1.2278-2.16992-2.2354-.29374-.7559-.26623-1.713-.20997-3.626L4.00081 5h3.99903c0-2.2091 1.79091-3.99994 3.99996-4Zm0 2c-1.1045.00006-1.99996.89547-1.99996 2h3.99996c0-1.10443-.8956-1.99978-2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 12h-2V9h2v3ZM15.9998 12h-2V9h2v3ZM21.9998 4h2v2h-2v2h-2V6h-2V4h2V2h2v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagAdd);
export default __webpack_public_path__ + "static/media/shoppingBagAdd.a51e7a45664e5df36f1b09d40b575940.svg";
export { ForwardRef as ReactComponent };